import { useState } from 'react';
import { Control, FieldErrors, UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { IFile } from 'coreOld/types';
import { IJob } from 'jobsOld/types';
import { IRequestJobs } from 'support/types';

import DisciplineJobTableView from './DisciplineJobTableView';

interface IProps {
  requestJobs: IJob[];
  control: Control<IRequestJobs, object>;
  getValues: UseFormGetValues<IRequestJobs>;
  setValue: UseFormSetValue<IRequestJobs>;
  errors?: FieldErrors<IRequestJobs>;
}

const DisciplineJobTable = ({ requestJobs, control, getValues, setValue, errors }: IProps) => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState<IJob | null>(null);

  const onUploadModalOpen = (job: IJob) => {
    setSelectedJob(job);
    setUploadModalOpen(true);
  };

  const onUploadModalClose = () => {
    setSelectedJob(null);
    setUploadModalOpen(false);
  };

  const onSubmitUploadFile = (files: IFile[]) => {
    const jobs = getValues('jobs');

    const newJobs = jobs.map((job) => {
      if (job.disciplineId === selectedJob?.disciplineId) {
        return {
          ...job,
          attachments: files,
        };
      }

      return job;
    });

    setValue('jobs', newJobs);
  };

  return (
    <DisciplineJobTableView
      requestJobs={requestJobs}
      control={control}
      getValues={getValues}
      setValue={setValue}
      errors={errors}
      selectedJob={selectedJob}
      uploadModalOpen={uploadModalOpen}
      onUploadModalOpen={onUploadModalOpen}
      onUploadModalClose={onUploadModalClose}
      onSubmitUploadFile={onSubmitUploadFile}
    />
  );
};

export default DisciplineJobTable;
